import { render, staticRenderFns } from "./lessons-audit.vue?vue&type=template&id=ec22396c&scoped=true"
import script from "./lessons-audit.vue?vue&type=script&lang=js"
export * from "./lessons-audit.vue?vue&type=script&lang=js"
import style0 from "./lessons-audit.vue?vue&type=style&index=0&id=ec22396c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec22396c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec22396c')) {
      api.createRecord('ec22396c', component.options)
    } else {
      api.reload('ec22396c', component.options)
    }
    module.hot.accept("./lessons-audit.vue?vue&type=template&id=ec22396c&scoped=true", function () {
      api.rerender('ec22396c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/lessons-audit.vue"
export default component.exports